import { store } from '../app/store';
import { logout } from '../features/auth/authSlice';
import { clearClientAuthStorage, redirectToPublicHome } from './authStorage';

/** Routes that require a live session — dead sessions redirect to the public homepage. */
export const PROTECTED_ROUTE_PREFIXES = [
  '/profile',
  '/appointments',
  '/dashboard',
  '/wishlist',
  '/saved-searches',
  '/appointment/',
];

export function getAppPath() {
  if (typeof window === 'undefined') return '/';
  return (window.location.pathname || '/').split('?')[0];
}

/** @deprecated use getAppPath */
export const getHashPath = getAppPath;

export function isProtectedRoute(path = getAppPath()) {
  return PROTECTED_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(prefix)
  );
}

export function isAuthProbeRequest(url = '') {
  return (
    url.includes('/auth/login') ||
    url.includes('/auth/check-email') ||
    url.includes('/auth/register') ||
    url.includes('/auth/forgot-password') ||
    url.includes('/auth/reset-password')
  );
}

export function isSuperAdminRequest(url = '') {
  return url.includes('/superadmin/') || url.includes('/cars/admin');
}

let redirectScheduled = false;

/** Clear client auth and send users on protected routes back to the public homepage. */
export function handleSessionExpired({ redirect = true } = {}) {
  const wasAuthenticated = store.getState().auth.isAuthenticated;
  clearClientAuthStorage();
  store.dispatch(logout());

  if (!redirect || redirectScheduled || !wasAuthenticated || !isProtectedRoute()) {
    return;
  }

  redirectScheduled = true;
  redirectToPublicHome();
}

export function installSessionExpiryInterceptor(axiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const url = error.config?.url || '';
        if (!isSuperAdminRequest(url) && !isAuthProbeRequest(url)) {
          handleSessionExpired();
        }
      }
      return Promise.reject(error);
    }
  );
}
